import general from './general';
import conneqt from './conneqt';
import settings from './settings';
import breadcrumbs from './breadcrumbs';

export default {
    pages: {
        settings: {
            title: 'Settings',
        },
    },
    
    general,
    conneqt,
    settings,
    breadcrumbs,
};
